// extracted by mini-css-extract-plugin
export default {"button":"Elub_"};